import * as React from "react";
import { Card } from "@bizform/primereact/card";
import { CardProps } from "@bizform/primereact/components/card/Card";
import { Static } from "@bizform/type/decorator/Static.decorator";
import {
    BaseStateModel,
    ComponentElement,
    ComponentElementDisplayMode,
    ComponentElementStatic,
    ComponentEventType
} from "@bizform/type/model/component_element/ComponentElement.model";
import { DefaultLayoutId } from "@bizform/type/model/component_element/DefaultLayoutId.model";
import {
    ComponentCategory,
    ComponentElementManifest,
    ComponentElementProperty
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import { ComponentHelper, Debug } from "@bizform/helper/dist/js/bizflow/helper.min";
import { ComponentElementClass, ReactComponentElementInit } from "@bizform/core/dist/js/bizflow/core.min";
import { AbstractComponentElement } from "../../bf_component/AbstractComponentElement";
import { I18n } from "../../misc/model/I18n.model";


type Props = CardProps & {
};

type WrappedCompState = {
    id?: string;
    header?: any;
    footer?: any;
    title?: string;
    subTitle?: string;
    style?: object;
    className?: string;
    useCustomContents?: boolean;
    contents?: string;
};

type State = BaseStateModel & {
    wrappedCompState: WrappedCompState;
};

/**
 * Card component element
 *
 * @since 0.0.1
 * @author BYUNGMIN CHOI
 * @class
 */
@ComponentElementClass()
@Static<ComponentElementStatic<null>>()
export class BfCard extends AbstractComponentElement<Props, State> {
    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_sQavhlIOU_wVEbi2ULNkDmSbsvrSRya",
        category: ComponentCategory.PANEL,
        label: I18n.layout.card.label,
        defaultLayoutId: DefaultLayoutId.ONLYCOMPONENTELEMENT,
        description: I18n.layout.card.description,
        icon: "",
        property: null
    };

    focus(): void {
    }

    setProperty(property: ComponentElementProperty): void {
        try {
            const newState = ComponentHelper.createStateWithProperties<State, ComponentEventType>(
                property,
                this);
            this.setState(newState);
        } catch (e) {
            this.emitDidCatch(e);
        }
    }

    emitFormState(value: string): void {
    }

    emitHasContainerKey(): void {
    }

    noDisplayInheritance() {
    }

    @ReactComponentElementInit(BfCard)
    static init(): ComponentElement<null> {
        return;
    }

    initDone(): void {
    }

    destroy(): void {
        this.destroyDone();
    }

    destroyDone(): void {
    }

    /* for React */
    props: Props;
    state: State;

    private _card: any;

    constructor(props?: Props) {
        super(props);

        this.state = {
            show: false,
            displayMode: ComponentElementDisplayMode.INIT,
            wrappedCompState: {
                title: null,
                subTitle: null,
                contents: null
            }
        };

        this._setRef = this._setRef.bind(this);
    }

    componentWillUnmount(): void {
        this._card = null;
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        this.emitDidCatch(error);
    }

    emitDidCatch(error: Error | any): void {
        Debug.console.error(error);
    }

    render(): React.ReactNode {
        if (!this.state.show) {
            return null;
        } else {
            let value: any = null;
            if (this.state.wrappedCompState.useCustomContents) {
                value = <div dangerouslySetInnerHTML={this._createContents()} />;
            } else {
                value = this.state.wrappedCompState.contents;
            }
            return (
                <Card
                    {...this.state.wrappedCompState}
                    ref={this._setRef}
                >
                    {value}
                </Card>
            );
        }
    }

    private _setRef(ref): void {
        if (ref) {
            this._card = ref;
            this.readyComponent();
        }
    }

    private _createContents() {
        return {__html: this.state.wrappedCompState.contents};
    }
}
